<ul class="snackbar-list">
  <li class="snackbar-list__item" *ngFor="let item of items">{{ item }}</li>
</ul>
